import React from 'react'

import TrendForm from 'pages/shared/TrendForm'

import { SinglePanePage } from 'styles/shared'
import { defaultTrend } from 'models/Trend'

const AddTrend = () => (
  <SinglePanePage>
    <TrendForm
      title="Add Trend"
      saveMethod="create"
      trend={defaultTrend}
    />
  </SinglePanePage>
)

export default AddTrend
